import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ButtonText from 'components/shared/ButtonText';
import TabIndicator from './TabIndicator';
import styles from './styles.module.scss';

function TabBar(props) {
  const handleClick = (e, tab) => {
    const { queryParam } = tab;
    if (queryParam !== '') window.HISTORY.push(`${props.location.pathname}?tab=${queryParam}`);
    else window.HISTORY.push(`${props.location.pathname}`);
  };

  return (
    <div className={classnames([styles.tabBar, { [styles.tabBarBorder]: props.border }])}>
      {props.tabs.map((tab, index) => {
        const { queryParam } = tab;
        const params = new URLSearchParams(props.location.search);
        const tabParam = params.get('tab');
        let active = false;
        if (queryParam !== '') active = tabParam === queryParam;
        else active = tabParam === null;
        return (
          <ButtonText
            muted={!active}
            onClick={e => handleClick(e, tab, index)}
            weight="regular"
            ref={active ? props.activeTabRef : null}
            styles={[styles.tabButton]}
            key={`${tab.label} [${tab.queryParam}]`}
            data-index={index}>
            {tab.label}
          </ButtonText>
        );
      })}

      <TabIndicator
        activeTabRef={props.activeTabRef}
        activeTabIndex={props.activeTabIndex}
        location={props.location}
      />
    </div>
  );
}

TabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      queryParam: PropTypes.string.isRequired,
      component: PropTypes.func.isRequired
    })
  ),
  activeTabRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  activeTabIndex: PropTypes.number,
  border: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired
};

TabBar.defaultProps = {
  tabs: [],
  activeTabRef: undefined,
  activeTabIndex: null
};

export default TabBar;
